'use client';

import { AuthCard } from '@/modules/authentication/presentation/components';
import { ResetPasswordForm } from '@/modules/authentication/presentation/forms';
import { ResetPasswordFormSchema, useResetPasswordForm  } from '@/modules/authentication/view-model';
import type { ResetPasswordFormModel } from '@/modules/authentication/view-model';

import { Form } from '@packages/hook-form-wrapper';

type ResetPasswordContainerProps = {
	oobCode: string
};

export const ResetPasswordContainer = ({ oobCode }: ResetPasswordContainerProps) => {
	const defaultValues = { oobCode };
	const { execute } = useResetPasswordForm();

	return (
		<AuthCard>
			<Form.Provider<ResetPasswordFormModel>
				defaultValues={defaultValues}
				onSubmit={execute}
				schema={ResetPasswordFormSchema}
			>
				<ResetPasswordForm />
			</Form.Provider>
		</AuthCard>
	);
};
